// Settings page.
export const settings: Record<string, string> = {
  'Manage your account and preferences': 'Upravljaj svojim nalogom i podešavanjima',
  // Account
  'Account': 'Nalog',
  'Current Email': 'Trenutna e-adresa',
  'Change Email': 'Promeni e-adresu',
  'New email address': 'Nova e-adresa',
  'Update Email': 'Ažuriraj e-adresu',
  'Change Password': 'Promeni lozinku',
  'New password': 'Nova lozinka',
  'Confirm new password': 'Potvrdi novu lozinku',
  'Update Password': 'Ažuriraj lozinku',
  'Danger Zone': 'Opasna zona',
  'Delete Account': 'Obriši nalog',
  'This action cannot be undone': 'Ova radnja se ne može opozvati',
  'All your trades, followers, and data will be permanently deleted. Are you absolutely sure?':
    'Svi tvoji trejdovi, pratioci i podaci biće trajno obrisani. Da li si potpuno siguran?',
  // Notifications
  'Notification Preferences': 'Podešavanja obaveštenja',
  'Likes on my trades': 'Lajkovi na moje trejdove',
  'Comments on my trades': 'Komentari na moje trejdove',
  'New followers': 'Novi pratioci',
  'Email me when a trader I follow changes SL/TP on a signal': 'Pošalji mi mejl kad trejder kog pratim izmeni SL/TP na signalu',
  'Save Preferences': 'Sačuvaj podešavanja',
  // Contact card (settings form + "Moj profil")
  'First name': 'Ime',
  'Last name': 'Prezime',
  'Phone': 'Telefon',
  'visible only to you': 'vidljivo samo tebi',
  'Social links': 'Društvene mreže',
  'shown publicly on your profile': 'javno prikazano na tvom profilu',
  'Contact': 'Kontakt',
  'Add phone number': 'Dodaj broj telefona',
  // Privacy
  'Privacy Controls': 'Kontrole privatnosti',
  'Public profile': 'Javni profil',
  'Allow anyone to view your profile': 'Dozvoli svima da vide tvoj profil',
  'Show trade statistics': 'Prikaži statistiku trejdova',
  'Display win rate and performance metrics': 'Prikaži procenat uspešnosti i metrike učinka',
  'Save Privacy': 'Sačuvaj privatnost',
  // Appearance
  'Appearance': 'Izgled',
  'Theme': 'Tema',
  '☀️ Light mode — Coming soon': '☀️ Svetla tema — uskoro',
  'Dark mode active': 'Tamna tema je aktivna',
  'dark': 'tamna',
  'light': 'svetla',
  // Language
  'Language': 'Jezik',
  // Profile
  'Profile Settings': 'Podešavanja profila',
  'Username': 'Korisničko ime',
  'Your username': 'Tvoje korisničko ime',
  'Bio': 'Biografija',
  'Tell traders about yourself…': 'Reci trejderima nešto o sebi…',
  'Profile Photo': 'Profilna fotografija',
  'Uploading...': 'Otpremanje...',
  'Upload Photo': 'Otpremi fotografiju',
  'JPG, PNG or WebP. Max 5MB.': 'JPG, PNG ili WebP. Maks. 5MB.',
  'Save Profile': 'Sačuvaj profil',
  // Toasts
  'Please enter a new email address.': 'Unesi novu e-adresu.',
  'Confirmation email sent. Check your inbox.': 'Imejl za potvrdu je poslat. Proveri sanduče.',
  'Failed to update email.': 'Ažuriranje e-adrese nije uspelo.',
  'Please enter a new password.': 'Unesi novu lozinku.',
  'Password must be at least 6 characters.': 'Lozinka mora imati najmanje 6 karaktera.',
  'Passwords do not match.': 'Lozinke se ne poklapaju.',
  'Password updated successfully.': 'Lozinka je uspešno ažurirana.',
  'Failed to update password.': 'Ažuriranje lozinke nije uspelo.',
  'Failed to sign out.': 'Odjava nije uspela.',
  'Account deletion failed. Please contact support.': 'Brisanje naloga nije uspelo. Kontaktiraj podršku.',
  'Notification preferences saved.': 'Podešavanja obaveštenja su sačuvana.',
  'Failed to save notifications.': 'Čuvanje podešavanja obaveštenja nije uspelo.',
  'Privacy settings saved.': 'Podešavanja privatnosti su sačuvana.',
  'Failed to save privacy settings.': 'Čuvanje podešavanja privatnosti nije uspelo.',
  'Image must be under 5MB.': 'Slika mora biti manja od 5MB.',
  'Use JPG, PNG, or WebP format.': 'Koristi JPG, PNG ili WebP format.',
  'Profile photo updated!': 'Profilna fotografija je ažurirana!',
  'Failed to upload photo.': 'Otpremanje fotografije nije uspelo.',
  'Username cannot be empty.': 'Korisničko ime ne može biti prazno.',
  'Profile updated successfully.': 'Profil je uspešno ažuriran.',
  'Failed to update profile.': 'Ažuriranje profila nije uspelo.',
  'Weekly email: top signals of the week': 'Nedeljni mejl: top signali nedelje',
};
